(() => {
  const data = JSON.parse(document.getElementById('FairfInteriorPreviews')?.textContent || '[]');
  const lang = (document.documentElement.lang || 'nl').slice(0, 2);
  const dict = {
    nl: { close: 'Sluiten ×', note: 'Licht en je beeldscherm beïnvloeden de kleur. Bekijk een echte kleurstaal in je eigen huis.', alt: 'interieurinspiratie', ai: 'AI-impressie', photo: 'Fotografie', view: 'Bekijk interieur' },
    en: { close: 'Close ×', note: 'Light and your screen affect how a colour looks. Always check a real sample at home.', alt: 'interior inspiration', ai: 'AI impression', photo: 'Photography', view: 'View interior' },
    fr: { close: 'Fermer ×', note: "La lumière et votre écran influencent la couleur. Vérifiez toujours avec un vrai échantillon chez vous.", alt: "inspiration d'intérieur", ai: 'Visuel IA', photo: 'Photographie', view: "Voir l'intérieur" },
    de: { close: 'Schließen ×', note: 'Licht und dein Bildschirm beeinflussen die Farbe. Prüfe sie immer mit einem echten Farbmuster bei dir zu Hause.', alt: 'Interior-Inspiration', ai: 'KI-Visualisierung', photo: 'Fotografie', view: 'Interior ansehen' }
  };
  const t = dict[lang] || dict.nl;
  const normalized = name => String(name).trim().toLowerCase();
  // Cards show a lighter rendition; the dialog keeps the full-size image.
  const sized = (url, width) => url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  // Touch screens have no hover: there the interior appears while a card crosses the middle of the screen.
  const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');
  const cards = new Map();
  const centreObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    const card = cards.get(entry.target); if (!card) return;
    card.state.centre = entry.isIntersecting; card.update();
  }), { rootMargin: '-49% 0px -49% 0px', threshold: 0 }) : null;
  const preloadObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    cards.get(entry.target)?.load(); preloadObserver.unobserve(entry.target);
  }), { rootMargin: '75% 0px 75% 0px', threshold: 0 }) : null;
  function watch(box) {
    if (!centreObserver) return;
    if (touchQuery.matches) { centreObserver.observe(box); preloadObserver.observe(box); }
    else { centreObserver.unobserve(box); preloadObserver.unobserve(box); const card = cards.get(box); if (card) { card.state.centre = false; card.update(); } }
  }
  const onModeChange = () => cards.forEach((card, box) => watch(box));
  if (touchQuery.addEventListener) touchQuery.addEventListener('change', onModeChange); else touchQuery.addListener?.(onModeChange);
  let dialog, returnFocus;
  function showDialog(item, trigger) {
    if (!dialog) {
      dialog = document.createElement('dialog'); dialog.className = 'fairf-interior-dialog';
      dialog.setAttribute('aria-labelledby', 'FairfInteriorTitle');
      const close = document.createElement('button'); close.type = 'button'; close.className = 'fairf-interior-close'; close.textContent = t.close; close.autofocus = true;
      const photo = document.createElement('img'); photo.width = 800; photo.height = 800;
      const title = document.createElement('h2'); title.id = 'FairfInteriorTitle';
      const credit = document.createElement('p'); credit.className = 'fairf-small'; credit.dataset.interiorCredit = '';
      const note = document.createElement('p'); note.className = 'fairf-small'; note.textContent = t.note;
      dialog.append(close, photo, title, credit, note); document.body.append(dialog);
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => returnFocus?.focus());
    }
    returnFocus = trigger;
    dialog.querySelector('img').src = item.url;
    dialog.querySelector('img').alt = `${item.name} — ${t.alt}`;
    dialog.querySelector('h2').textContent = item.name;
    dialog.querySelector('[data-interior-credit]').textContent = `${item.ai ? t.ai : t.photo} · ${item.credit}`;
    dialog.showModal();
  }
  function prepare(card) {
    if (card.dataset.previewReady) return;
    const item = data.find(item => normalized(item.name) === normalized(card.dataset.previewColour));
    if (!item) return;
    const media = card.querySelector('.fairf-favorite__paint, i, .card__media .media');
    if (!media) return;
    card.dataset.previewReady = 'true';
    let box = card;
    if (card.tagName === 'A') {
      box = document.createElement('div'); box.className = 'fairf-preview-card'; card.before(box); box.append(card);
    }
    box.classList.add('fairf-has-interior'); media.classList.add('fairf-interior-media');
    const image = document.createElement('img'); image.className = 'fairf-interior-photo'; image.width = 800; image.height = 800; image.alt = ''; image.setAttribute('aria-hidden', 'true'); image.decoding = 'async';
    const badge = document.createElement('span'); badge.className = 'fairf-interior-badge'; badge.setAttribute('aria-hidden', 'true'); badge.textContent = item.ai ? t.ai : item.credit;
    media.append(image, badge);
    let loaded = false;
    const load = () => { if (!loaded) { image.src = sized(item.url, 800); loaded = true; } };
    const state = { hover: false, focus: false, centre: false };
    const update = () => {
      const visible = state.hover || state.focus || state.centre;
      if (visible) load();
      media.classList.toggle('is-previewing', visible);
    };
    cards.set(box, { state, update, load });
    box.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { state.hover = true; update(); } });
    box.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { state.hover = false; update(); } });
    box.addEventListener('focusin', () => { state.focus = true; update(); });
    box.addEventListener('focusout', event => { if (!box.contains(event.relatedTarget)) { state.focus = false; update(); } });
    const button = document.createElement('button'); button.type = 'button'; button.className = 'fairf-interior-trigger';
    button.textContent = t.view; button.setAttribute('aria-label', `${button.textContent}: ${item.name}`); button.setAttribute('aria-haspopup', 'dialog');
    button.addEventListener('click', () => showDialog(item, button)); box.append(button);
    watch(box);
  }
  const scan = node => { if (node.nodeType !== 1) return; if (node.matches('[data-preview-colour]')) prepare(node); node.querySelectorAll('[data-preview-colour]').forEach(prepare); };
  scan(document.body);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
})();